<template lang="pug">
.gps-editor(v-if="mapCenter")
  GmapMap(
    ref="mapRef",
    :center="mapCenter",
    :zoom="zoom",
    :options="{ gestureHandling: 'greedy' }",
    style="width: 100%; height: 80vh",
    @click="handleMapClick",
    @tilesloaded="mapReady = true"
  )
    GmapMarker(
      v-if="mapReady && hasOwnCoords",
      :position="originalCoords",
      :icon="'https://maps.google.com/mapfiles/kml/pushpin/wht-pushpin.png'"
    )
    GmapMarker(
      v-if="mapReady && selectedCoords",
      :position="selectedCoords",
      :draggable="true",
      @dragend="onMarkerDragEnd",
      :icon="'https://maps.google.com/mapfiles/kml/pushpin/grn-pushpin.png'"
    )
</template>

<script>
export default {
  name: "GpsEditor",
  props: {
    media: Object,
    initialCoords: Object, // { lat, lng }
    initialZoom: {
      type: Number,
      default: 16,
    },
    hasOwnCoords: Boolean
  },
  data() {
    return {
      mapReady: false,
      mapCenter: null,
      selectedCoords: null,
      originalCoords: null,
      zoom: this.initialZoom,
    };
  },
  created() {
    const coords = this.initialCoords;
    const validCoords =
      coords &&
      typeof coords.lat === "number" &&
      typeof coords.lng === "number" &&
      !isNaN(coords.lat) &&
      !isNaN(coords.lng) &&
      !(coords.lat === 0 && coords.lng === 0);

    this.mapCenter = coords || { lat: 51, lng: 8 }; // Für Anzeige
    this.originalCoords = validCoords ? coords : null;
    this.hasOriginalCoords = validCoords;
    console.log("map center", this.mapCenter);
  },
  //   watch: {
  //     initialCoords: {
  //       immediate: true,
  //       handler(coords) {
  //         const isValidCoords =
  //           coords &&
  //           typeof coords.lat === "number" &&
  //           typeof coords.lng === "number" &&
  //           (coords.lat !== 0 || coords.lng !== 0); // 0/0 ist meistens kein valider GPS-Punkt

  //         this.mapCenter = coords || { lat: 51.0, lng: 8.0 };
  //         this.originalCoords = isValidCoords ? coords : null;
  //         this.selectedCoords = null;
  //       },
  //     },
  //   },
  methods: {
    handleMapClick(event) {
      this.selectedCoords = {
        lat: event.latLng.lat(),
        lng: event.latLng.lng(),
      };
    },
    onMarkerDragEnd(event) {
      this.selectedCoords = {
        lat: event.latLng.lat(),
        lng: event.latLng.lng(),
      };
    },
    getCurrentCoordinates() {
      return this.selectedCoords
        ? {
            latitude: this.selectedCoords.lat,
            longitude: this.selectedCoords.lng,
          }
        : null;
    },
    getCurrentCenter() {
      const center = this.$refs.mapRef.$mapObject.getCenter();
      return center ? { lat: center.lat(), lng: center.lng() } : null;
    },
    getCurrentZoom() {
      return this.$refs.mapRef.$mapObject.getZoom();
    },
  },
};
</script>

<style scoped>
.gps-editor {
  width: 100%;
  height: 100%;
}
</style>
